export default __webpack_public_path__ + "static/media/mobilepreviewtop.273e3e8e.svg";